import { render, staticRenderFns } from "./RFMMapv2Section.vue?vue&type=template&id=a1a181c6&scoped=true&"
import script from "./RFMMapv2Section.vue?vue&type=script&lang=js&"
export * from "./RFMMapv2Section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a181c6",
  null
  
)

export default component.exports